export default "__VITE_ASSET__V4F29_MV__"